import * as api from '../../../../../api/masters/users/loginLog/loginLogApi';
import {
  FETCH_LOGIN_LOGS_REQUEST,
  FETCH_LOGIN_LOGS_SUCCESS,
  FETCH_LOGIN_LOGS_FAILURE
} from '../../../../types/masters/users/loginLog/loginLogTypes';

export const fetchLoginLogs = (user_id) => async (dispatch) => {
  dispatch({ type: FETCH_LOGIN_LOGS_REQUEST });
  try {
    const logs = await api.fetchLoginLogs(user_id);
    dispatch({ type: FETCH_LOGIN_LOGS_SUCCESS, payload: logs });
  } catch (error) {
    dispatch({ type: FETCH_LOGIN_LOGS_FAILURE, error: error.message });
  }
}; 